// Vocabulary category interfaces
export interface VocabularyCategory {
  id: string;
  title: string;
  subtitle: string;
  wordCount: string;
  highlight?: boolean;
}

export interface ExamTab {
  value: string;
  label: string;
}

// College vocabulary categories
export const vocabularyCategories: VocabularyCategory[] = [
  {
    id: "cet4",
    title: "CET-4",
    subtitle: "大学英语四级词库",
    wordCount: "2607 词",
  },
  {
    id: "cet6",
    title: "CET-6",
    subtitle: "大学英语六级词库",
    wordCount: "2345 词",
  },
  {
    id: "cet4-quick",
    title: "四级巧记速记",
    subtitle: "四级巧记速记",
    wordCount: "2522 词",
  },
  {
    id: "cet6-quick",
    title: "六级巧记速记",
    subtitle: "六级巧记速记",
    wordCount: "7520 词",
  },
  {
    id: "cet4-sub",
    title: "CET-4-Sub",
    subtitle: "单词的减法-四级",
    wordCount: "1957 词",
  },
  {
    id: "cet6-sub",
    title: "CET-6-Sub",
    subtitle: "单词的减法-六级",
    wordCount: "1949 词",
  },
  {
    id: "te4",
    title: "专四",
    subtitle: "英语专业四级词库",
    wordCount: "4025 词",
  },
  {
    id: "te8",
    title: "专八",
    subtitle: "英语专业八级词库",
    wordCount: "12197 词",
  },
  {
    id: "graduate",
    title: "专升本3000词",
    subtitle: "专升本词汇",
    wordCount: "2991 词",
  },
];

// Graduate school vocabulary categories (考研)
export const kaoyanCategories: VocabularyCategory[] = [
  {
    id: "level2",
    title: "超频单词level 2",
    subtitle: "超频单词level 2",
    wordCount: "1040 词",
  },
  {
    id: "kaoyan",
    title: "考研",
    subtitle: "研究生英语入学考试词库",
    wordCount: "3728 词",
  },
  {
    id: "kaoyan2024",
    title: "考研 2024",
    subtitle: "研究生英语入学考试词库 2024",
    wordCount: "3731 词",
  },
  {
    id: "kaoyan2023",
    title: "考研闪过 2023",
    subtitle: "高中低频词2023",
    wordCount: "1771 词",
  },
  {
    id: "kaoyan926",
    title: "考研926词汇",
    subtitle: "926核心词汇",
    wordCount: "926 词",
  },
  {
    id: "mimi1",
    title: "单词的秘密-英语一",
    subtitle: "单词的秘密英语（一）",
    wordCount: "5657 词",
  },
  {
    id: "mimi2",
    title: "单词的秘密-英语二",
    subtitle: "单词秘密英语（二）",
    wordCount: "3827 词",
  },
  {
    id: "hongbao1",
    title: "2024考研英语hongbaoshu(上)",
    subtitle: "2024考研英语hongbaoshu必考词（上）",
    wordCount: "997 词",
  },
  {
    id: "hongbao2",
    title: "2024考研英语hongbaoshu(下)",
    subtitle: "2024考研英语hongbaoshu必考词（下）",
    wordCount: "854 词",
  },
  {
    id: "hongbao2026",
    title: "2026考研英语 hongbaoshu",
    subtitle: "2026 考研词汇（必考词+基础词+超纲词）",
    wordCount: "4858 词",
  },
  {
    id: "dan2",
    title: "英语二单词书",
    subtitle: "考研英语二单词书",
    wordCount: "4559 词",
  },
  {
    id: "shangguo2025",
    title: "考研 shangguo 2025",
    subtitle: "考研 shangguo 2025",
    wordCount: "2257 词",
  },
  {
    id: "hongbao2025",
    title: "2025考研英语词汇hongbao书",
    subtitle: "2025考研英语词汇hongbao书",
    wordCount: "6705 词",
  },
];

// Professional English categories
export const professionalCategories: VocabularyCategory[] = [
  {
    id: "architecture",
    title: "建筑专业英语",
    subtitle: "大学建筑专业英语词汇",
    wordCount: "630 词",
  },
  {
    id: "computer",
    title: "计算机专用英语",
    subtitle: "大学计算机专业英语词汇",
    wordCount: "1665 词",
  },
];

// PET categories
export const petCategories: VocabularyCategory[] = [
  {
    id: "pets",
    title: "PETS",
    subtitle: "全国英语等级考试常考词汇",
    wordCount: "1942 词",
  },
  {
    id: "pets-2023",
    title: "PETS-2023",
    subtitle: "全国英语等级考试常考词汇",
    wordCount: "4449 词",
  },
];

// Self-study English Level 2 categories
export const selfStudyCategories: VocabularyCategory[] = [
  {
    id: "self-1800",
    title: "自考1800高频单词",
    subtitle: "自考1800高频单词",
    wordCount: "1800 词",
  },
  {
    id: "self-high-freq",
    title: "自考英语二高频悠悠单词",
    subtitle: "自考英语二高频悠悠单词",
    wordCount: "2181 词",
  },
  {
    id: "self-complete",
    title: "自考英语二完整单词",
    subtitle: "00015自考英语二完整单词书",
    wordCount: "4603 词",
  },
];

// Other categories
export const otherCategories: VocabularyCategory[] = [
  {
    id: "coca-20000",
    title: "COCA20000词",
    subtitle: "COCA20000词",
    wordCount: "20199 词",
  },
  {
    id: "essential-meaning",
    title: "Essential Words",
    subtitle: "4000 Essential English Words meaning",
    wordCount: "3600 词",
  },
  {
    id: "essential-sentence",
    title: "Essential Words",
    subtitle: "4000 Essential English Words sentence",
    wordCount: "3600 词",
  },
  {
    id: "longman",
    title: "Longman Communication 3000",
    subtitle: "Most frequent words in both spoken and written English",
    wordCount: "3168 词",
  },
  {
    id: "top-2000",
    title: "Top 2000 words",
    subtitle: "with highest frequency",
    wordCount: "1867 词",
  },
  {
    id: "top-1500-nouns",
    title: "Top 1500 Nouns",
    subtitle: "with highest frequency",
    wordCount: "1525 词",
  },
  {
    id: "top-1000-verbs",
    title: "Top 1000 Verbs",
    subtitle: "with highest frequency",
    wordCount: "1011 词",
  },
  {
    id: "top-500-adj",
    title: "Top 500 adj.",
    subtitle: "with highest frequency",
    wordCount: "527 词",
  },
  {
    id: "top-250-adv",
    title: "Top 250 adv.",
    subtitle: "with highest frequency",
    wordCount: "255 词",
  },
  {
    id: "top-60-pron",
    title: "Top 60 pron.",
    subtitle: "with highest frequency",
    wordCount: "59 词",
  },
  {
    id: "top-50-prep",
    title: "Top 50 prep.",
    subtitle: "with highest frequency",
    wordCount: "46 词",
  },
  {
    id: "suffix-word",
    title: "suffix word",
    subtitle: "common suffix",
    wordCount: "126 词",
  },
  {
    id: "word-roots",
    title: "word roots1",
    subtitle: "common roots",
    wordCount: "369 词",
  },
  {
    id: "zk-ben",
    title: "专升本词汇",
    subtitle: "专升本词汇",
    wordCount: "3692 词",
  },
  {
    id: "zs-english",
    title: "专插本英语词汇",
    subtitle: "专插本英语词汇",
    wordCount: "3217 词",
  },
  {
    id: "zs-bachelor",
    title: "专升本学士学位的英语",
    subtitle: "专升本学士学位的英语",
    wordCount: "897 词",
  },
  {
    id: "niu-5000",
    title: "牛津5000词",
    subtitle: "牛津5000词",
    wordCount: "5836 词",
  },
  {
    id: "wei-root",
    title: "韦氏词根词典",
    subtitle: "韦氏词根词典",
    wordCount: "1191 词",
  },
  {
    id: "hearing-test",
    title: "听说考试常见词汇",
    subtitle: "听说考试16个场景常见词汇量",
    wordCount: "557 词",
  },
  {
    id: "level-1",
    title: "超频单词level 1",
    subtitle: "超频单词level 1",
    wordCount: "679 词",
  },
  {
    id: "level-2",
    title: "超频单词level 2",
    subtitle: "超频单词level 2",
    wordCount: "1040 词",
  },
  {
    id: "level-3",
    title: "超频单词level 3",
    subtitle: "超频单词level 3",
    wordCount: "1435 词",
  },
  {
    id: "mac-7000",
    title: "麦克米伦7000",
    subtitle: "麦克米伦7000",
    wordCount: "6268 词",
  },
];

// Exam tabs configuration
export const examTabs: ExamTab[] = [
  { value: "TOEFL", label: "TOEFL" },
  { value: "PET", label: "PET" },
  { value: "GMAT", label: "GMAT" },
  { value: "GRE", label: "GRE" },
  { value: "IELTS", label: "IELTS" },
  { value: "KET", label: "KET" },
  { value: "SAT", label: "SAT" },
  { value: "BEC", label: "BEC" },
  { value: "PTE", label: "PTE" },
  { value: "TOEIC", label: "TOEIC" },
  { value: "CEFR", label: "CEFR" },
  { value: "牛津版", label: "牛津版" },
  { value: "其他", label: "其他" },
  { value: "FCE", label: "FCE" },
];

// Exam cards data
export const examCardsData: Record<string, VocabularyCategory[]> = {
  TOEFL: [
    {
      id: "zhy-toefl",
      title: "ZhangHongYan的TOEFL词汇书",
      subtitle: "ZhangHongYan的TOEFL词汇书-词以类记",
      wordCount: "4032 词",
    },
    {
      id: "toefl",
      title: "TOEFL",
      subtitle: "托福考试常见词",
      wordCount: "4264 词",
    },
  ],
  PET: [
    {
      id: "pet-2024-exam",
      title: "PET-2024",
      subtitle: "剑桥英语 - 2024",
      wordCount: "1871 词",
    },
  ],
  GMAT: [
    {
      id: "gmat-vocab",
      title: "GMAT 词库",
      subtitle: "GMAT 词库",
      wordCount: "3047 词",
    },
  ],
  GRE: [
    {
      id: "gre-vocab",
      title: "GRE",
      subtitle: "GRE 词库",
      wordCount: "6515 词",
    },
    {
      id: "gre-1500-fen",
      title: "GRE重点1500词-fen哥",
      subtitle: "GRE & TEM8 重高高频词汇",
      wordCount: "1533 词",
    },
    {
      id: "gre3000",
      title: "GRE3000",
      subtitle: "GRE3000 词库",
      wordCount: "3041 词",
    },
    {
      id: "gre-jingji-vocab",
      title: "GRE机经词汇",
      subtitle: "GRE机经词汇",
      wordCount: "1451 词",
    },
    {
      id: "gre3000-new",
      title: "再要你命GRE3000",
      subtitle: "再要你命GRE3000词库-有词性新版",
      wordCount: "3041 词",
    },
    {
      id: "gre-equiv",
      title: "GRE等价词",
      subtitle: "GRE等价词",
      wordCount: "827 词",
    },
    {
      id: "gre-by-category",
      title: "GRE词以类记",
      subtitle: "GRE词以类记",
      wordCount: "8785 词",
    },
  ],
  IELTS: [
    {
      id: "ielts-scene-vocab",
      title: "雅思听力场景词汇",
      subtitle: "雅思听力场景词汇",
      wordCount: "1204 词",
    },
    {
      id: "ielts-listening",
      title: "IELTS乱序完整版",
      subtitle: "IELTS乱序完整版",
      wordCount: "9389 词",
    },
    {
      id: "ielts-speaking",
      title: "IELTS剑桥完整版",
      subtitle: "IELTS剑桥完整版",
      wordCount: "9389 词",
    },
    {
      id: "ielts-vocab",
      title: "IELTS",
      subtitle: "雅思词库",
      wordCount: "3575 词",
    },
    {
      id: "heqiong-ielts",
      title: "heQiong雅思听力必考词汇",
      subtitle: "雅思词汇",
      wordCount: "2529 词",
    },
    {
      id: "ielts-wang-c3",
      title: "雅思wang C3",
      subtitle: "雅思听力特训剑桥真题集",
      wordCount: "1135 词",
    },
    {
      id: "ielts-wang-c4",
      title: "雅思wang C4",
      subtitle: "雅思听力特训剑桥真题集",
      wordCount: "346 词",
    },
    {
      id: "ielts-wang-c5",
      title: "雅思wang C5",
      subtitle: "雅思听力特训剑桥真题集",
      wordCount: "1569 词",
    },
    {
      id: "ielts-wang-c11",
      title: "雅思wang C11",
      subtitle: "雅思词汇",
      wordCount: "1738 词",
    },
    {
      id: "yati-ielts-core",
      title: "鸭题雅思核心词",
      subtitle: "鸭题雅思核心词",
      wordCount: "2644 词",
    },
    {
      id: "ielts-vocab-bible",
      title: "雅思词汇真经",
      subtitle: "雅思词汇真经",
      wordCount: "3673 词",
    },
    {
      id: "ielts-wangu-807",
      title: "雅思 wanglu 807",
      subtitle: "雅思 wanglu 807",
      wordCount: "4340 词",
    },
    {
      id: "ielts-9988wangyong",
      title: "雅思9988wangyong",
      subtitle: "雅思9988wangyong",
      wordCount: "3698 词",
    },
    {
      id: "wangu807-listen-v2",
      title: "wanglu807雅思词汇听力方法2版",
      subtitle: "wanglu807雅思词汇听力方法2版",
      wordCount: "1916 词",
    },
    {
      id: "100-sentence-7000-words",
      title: "100个句子记7000个雅思单词",
      subtitle: "xdf 100个句子记7000个雅思单词 上下",
      wordCount: "5967 词",
    },
    {
      id: "ielts-speaking-900-beta",
      title: "雅思口语 900 beta版",
      subtitle: "雅思口语 900 句, 基于 qwerty 语境",
      wordCount: "900 词",
    },
  ],
  KET: [
    {
      id: "ket-2021",
      title: "KET",
      subtitle: "KET 2021词汇",
      wordCount: "1147 词",
    },
  ],
  SAT: [
    {
      id: "sat-vocab",
      title: "SAT",
      subtitle: "美国 SAT 考试词库",
      wordCount: "4464 词",
    },
    {
      id: "sat-en-cn",
      title: "SAT en-cn",
      subtitle: "SAT双语",
      wordCount: "2681 词",
    },
  ],
  BEC: [
    {
      id: "bec-business",
      title: "商务英语",
      subtitle: "商务英语常见词汇",
      wordCount: "2753 词",
    },
    {
      id: "bec-vocab",
      title: "BEC",
      subtitle: "BEC考试常见词汇",
      wordCount: "2825 词",
    },
  ],
  PTE: [
    {
      id: "pte-basic",
      title: "PTE 基础词汇",
      subtitle: "PTE 基础词汇",
      wordCount: "2651 词",
    },
    {
      id: "pte-advanced",
      title: "PTE 高阶词汇",
      subtitle: "PTE 高阶词汇",
      wordCount: "3170 词",
    },
    {
      id: "pte-fib-basic",
      title: "阅读 FIB 基础机经词汇",
      subtitle: "阅读 FIB 基础机经词汇",
      wordCount: "941 词",
    },
    {
      id: "pte-fib-advanced",
      title: "阅读 FIB 高阶机经词汇",
      subtitle: "阅读 FIB 高阶机经词汇",
      wordCount: "1272 词",
    },
    {
      id: "wfd-vocab",
      title: "WFD 机经词汇",
      subtitle: "WFD 机经词汇",
      wordCount: "1212 词",
    },
    {
      id: "listening-fib-vocab",
      title: "听力 FIB 机经词汇",
      subtitle: "听力 FIB 机经词汇",
      wordCount: "646 词",
    },
    {
      id: "pte-basic-xingji",
      title: "PTE 基础词汇 xingji",
      subtitle: "PTE 基础词汇 xingji",
      wordCount: "2652 词",
    },
    {
      id: "pte-advanced-xingji",
      title: "PTE 高阶词汇 xingji",
      subtitle: "PTE 高阶词汇 xingji",
      wordCount: "3169 词",
    },
    {
      id: "pte-reading-fib-xingji",
      title: "PTE 阅读FIB机经词汇 xingji",
      subtitle: "PTE 阅读FIB机经词汇 xingji",
      wordCount: "630 词",
    },
    {
      id: "pte-listening-fib-xingji",
      title: "PTE 听力FIB机经词汇 xingji",
      subtitle: "PTE 听力FIB机经词汇 xingji",
      wordCount: "674 词",
    },
    {
      id: "pte-common-vocab",
      title: "PTE 常用短语 (非官方)",
      subtitle: "PTE 常用短语",
      wordCount: "274 词",
    },
  ],
  TOEIC: [
    {
      id: "toeic-vocab",
      title: "TOEIC 词汇",
      subtitle: "TOEIC 词汇",
      wordCount: "1694 词",
    },
  ],
  CEFR: [
    {
      id: "cefr-b1",
      title: "多邻国分级词汇B1",
      subtitle: "多邻国分级词汇B1",
      wordCount: "801 词",
    },
    {
      id: "cefr-b2",
      title: "多邻国分级词汇B2",
      subtitle: "多邻国分级词汇B2",
      wordCount: "1423 词",
    },
    {
      id: "cefr-c1",
      title: "多邻国分级词汇C1",
      subtitle: "多邻国分级词汇C1",
      wordCount: "1314 词",
    },
  ],
  牛津版: [
    {
      id: "oxford-3000",
      title: "牛津3000词",
      subtitle: "牛津3000词",
      wordCount: "1342 词",
    },
    {
      id: "oxford-5000",
      title: "牛津5000词",
      subtitle: "牛津5000词",
      wordCount: "5836 词",
    },
  ],
  其他: [
    {
      id: "voa-basic",
      title: "VOA 基础词库",
      subtitle: "VOA 基础词库",
      wordCount: "1505 词",
    },
  ],
  FCE: [
    {
      id: "fce-common",
      title: "FCE 常用短语 (非官方)",
      subtitle: "FCE 常用短语",
      wordCount: "438 词",
    },
  ],
};

// Dictionary mapping
export const dictionaryMapping: Record<string, string> = {
  // College dictionaries
  cet4: "CET4_T.json",
  cet6: "CET6_T.json",
  "cet4-quick": "xinghuoqiaoji_4.json",
  "cet6-quick": "xinghuoqiaoji_6.json",
  "cet4-sub": "DanCiDeJianFa_4.json",
  "cet6-sub": "DanCiDeJianFa_6.json",
  te4: "Level4luan_2_T.json",
  te8: "Level8luan_2_T.json",
  graduate: "3000_ClassRoom_English_Words.json",
  // Graduate dictionaries
  kaoyan: "KaoYan_3_T.json",
  kaoyan2024: "KaoYan_2024.json",
  kaoyan2023: "KaoYanShanGuo_2023.json",
  kaoyan926: "926.json",
  mimi1: "DanCiDeMimi_1.json",
  mimi2: "DanCiDeMimi_2.json",
  hongbao1: "2024HongBao_T1.json",
  hongbao2: "2024HongBao_T2.json",
  hongbao2026: "hongbaoshu-2026.json",
  dan2: "English_II.json",
  shangguo2025: "kaoyanshanguo2025.json",
  hongbao2025: "2025KaoYanHongBaoShu.json",
  // TOEFL dictionaries
  toefl: "TOEFL_3_T.json",
  "zhy-toefl": "TOEFL_ZhangHongYan.json",
  // Professional English dictionaries
  architecture: "archVocabulary.json",
  computer: "itVocabulary.json",
  // PET dictionaries
  pets: "PETS_3.json",
  "pets-2023": "PETS_2023.json",
  "pet-2024-exam": "pet-vacabulary-list-2024.json",
  // GMAT dictionaries
  "gmat-vocab": "GMAT_3_T.json",
  // GRE dictionaries
  "gre-vocab": "GRE_3_T.json",
  "gre-1500-fen": "GRE_1500.json",
  gre3000: "GRE3000_3_T.json",
  "gre-jingji-vocab": "GRE-computer-based-test.json",
  "gre3000-new": "ZaiYaoNiMing_GRE3000.json",
  "gre-equiv": "GRE_equivalent.json",
  "gre-by-category": "gre-ciyileiji.json",
  // IELTS dictionaries
  "ielts-scene-vocab": "IELTS_tinglichangjing.json",
  "ielts-listening": "IELTS_disorder.json",
  "ielts-speaking": "IELTS_order.json",
  "ielts-vocab": "IELTS_3_T.json",
  "heqiong-ielts": "HeQiong_IELTS.json",
  "ielts-wang-c3": "IELTS_WANG_3.json",
  "ielts-wang-c4": "IELTS_WANG_4.json",
  "ielts-wang-c5": "IELTS_WANG_5.json",
  "ielts-wang-c11": "IELTS_WANG_11.json",
  "yati-ielts-core": "DuckCircle_IELTS.json",
  "ielts-vocab-bible": "IELTSVocabularyBible.json",
  "ielts-wangu-807": "ielts-807.json",
  "ielts-9988wangyong": "IELTS9988wangyong.json",
  "wangu807-listen-v2": "IELTSKingLu807.json",
  "100-sentence-7000-words": "IELTS_XDF_7000.json",
  "ielts-speaking-900-beta": "IELTS-oral-900.json",
  // KET dictionaries
  "ket-2021": "ket2021.json",
  // SAT dictionaries
  "sat-vocab": "SAT_3_T.json",
  "sat-en-cn": "SATen.json",
  // BEC dictionaries
  "bec-business": "BEC_2_T.json",
  "bec-vocab": "BEC_3_T.json",
  // PTE dictionaries
  "pte-basic": "PTE_junior.json",
  "pte-advanced": "PTE_senior.json",
  "pte-fib-basic": "PTE_FIB_R_junior.json",
  "pte-fib-advanced": "PTE_FIB_R_senior.json",
  "wfd-vocab": "PTE_WFD.json",
  "listening-fib-vocab": "PTE_FIB_L.json",
  "pte-basic-xingji": "PTE_Basic_apeuni.json",
  "pte-advanced-xingji": "PTE_Advanced_apeuni.json",
  "pte-reading-fib-xingji": "PTE_Read_apeuni.json",
  "pte-listening-fib-xingji": "PTE_Listening_apeuni.json",
  "pte-common-vocab": "Common-Phrases-PTE-Unofficial.json",
  // TOEIC dictionaries
  "toeic-vocab": "TOEIC.json",
  // CEFR dictionaries
  "cefr-b1": "Duolingo_Vocabulary_B1.json",
  "cefr-b2": "Duolingo_Vocabulary_B2.json",
  "cefr-c1": "Duolingo_Vocabulary_C1.json",
  // Oxford dictionaries
  "oxford-3000": "Oxford3000.json",
  "oxford-5000": "Oxford5000.json",
  // Other dictionaries
  "voa-basic": "voa.json",
  // FCE dictionaries
  "fce-common": "Common-Phrases-FCE-Unofficial.json",
  // Self-study English Level 2 dictionaries
  "self-1800": "self-study_English1.json",
  "self-high-freq": "self-study_English2.json",
  "self-complete": "self-study_English3.json",
  // Other dictionaries
  "coca-20000": "coca20000.json",
  "essential-meaning": "4000_Essential_English_Words-meaning.json",
  "essential-sentence": "4000_Essential_English_Words-sentence.json",
  longman: "Longman_Communication_3000.json",
  "top-2000": "top2000words.json",
  "top-1500-nouns": "Top1500NounWords.json",
  "top-1000-verbs": "Top1000VerbWords.json",
  "top-500-adj": "Top500AdjectiveWords.json",
  "top-250-adv": "Top250AdverbWords.json",
  "top-60-pron": "Top60Pronouns.json",
  "top-50-prep": "Top50Prepositions.json",
  "suffix-word": "suffix_word.json",
  "word-roots": "word_roots1.json",
  "zk-ben": "adult-self-study-examination.json",
  "zs-english": "zhuan-cha-ben.json",
  "zs-bachelor": "xueshiyingyu.json",
  "niu-5000": "Oxford5000.json",
  "wei-root": "Merriam_Webster_sVocabularyBuilder.json",
  "hearing-test": "tingshuokaoshi.json",
  "level-1": "frequently_used_word01.json",
  "level-2": "frequently_used_word02.json",
  "level-3": "frequently_used_word03.json",
  "mac-7000": "Macmillan7000.json",
};

// Helper function to get category data by tab
export const getCategoriesByTab = (tab: string): VocabularyCategory[] => {
  switch (tab) {
    case "college":
      return vocabularyCategories;
    case "graduate":
      return kaoyanCategories;
    case "professional":
      return professionalCategories;
    case "pet":
      return petCategories;
    case "self":
      return selfStudyCategories;
    case "other":
      return otherCategories;
    default:
      return [];
  }
};

// Helper function to get default dictionary file
export const getDefaultDictionaryFile = (cardId: string): string => {
  return dictionaryMapping[cardId] || "words.json";
};

// Helper function to create reverse dictionary mapping
export const createReverseDictionaryMapping = (): Record<string, string[]> => {
  return Object.entries(dictionaryMapping).reduce(
    (acc, [cardId, filename]) => {
      acc[filename] = acc[filename] || [];
      acc[filename].push(cardId);
      return acc;
    },
    {} as Record<string, string[]>
  );
};